<div class="d-flex flex-column">
    <strong *ngIf="percent">{{ percent.toFixed(0) }}%</strong>
    <div class="progress progress-sm"
         [style.width]="'90px'">
        <div class="progress-bar bg-primary" 
             role="progressbar"
             [style.width]="percent + '%'"
             aria-valuemin="0" aria-valuemax="100"></div>
    </div>
</div>
